import { fromJS, Map } from 'immutable';

export const createDelete = ({
    params = {},
    types,
    url,
}) => {
    return (data, query = {}) => (dispatch) => {
        const { DELETE, DELETE_FAIL, DELETE_SUCCESS } = types;

        const combinedParams = fromJS({
            ...params,
            ...query,
        });

        return dispatch({
            data,
            payload: {
                request: {
                    method: 'delete',
                    params: combinedParams.toJS(),
                    url: `${url}/${data.get('id')}`,
                },
            },
            types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
        });
    };
};

export const createFetchCollection = ({
    name,
    params = {},
    types,
    url,
}) => {
    return (query = {}, id, refresh = false) => (dispatch, getState) => {
        const state = getState()[name];

        if (!state) {
            throw new Error(`Could not find "${name}" in redux state. Are you sure you passed the correct name to "${name}" actions?`);
        }

        const combinedParams = {
            ...params,
            ...query,
        };

        const fiveMinutesAgo = Date.now() - 300000;
        const requestId = JSON.stringify({ combinedParams, id, url });
        const cachedRequest = state.getIn(['cache', requestId], Map({}));
        const fetchedInPastFiveMinutes = cachedRequest.get('lastFetched', 0) > fiveMinutesAgo;
        const isCacheEqualToState = cachedRequest.get('data', Map({})).equals(state.get('data', Map({})));
        const { EDIT_IN, FETCH, FETCH_FAIL, FETCH_SUCCESS } = types;

        // If result is cached do not make call again and use cached data
        if (isCacheEqualToState && fetchedInPastFiveMinutes && !refresh) {
            dispatch({
                path: ['data'],
                type: EDIT_IN,
                value: cachedRequest.get('data'),
            });

            return Promise.resolve();
        }

        return dispatch({
            payload: {
                request: {
                    params: combinedParams,
                    url: id ? `${url}/${id}` : url,
                },
            },
            requestId,
            types: [FETCH, FETCH_SUCCESS, FETCH_FAIL],
        });
    };
};

export const createFetchResource = ({
    name,
    params = {},
    types,
    url,
}) => {
    return (id, query = {}, refresh = false) => (dispatch, getState) => {
        const state = getState()[name];

        if (!state) {
            throw new Error(`Could not find "${name}" in redux state. Are you sure you passed the correct name to "${name}" actions?`);
        }

        const combinedParams = {
            ...params,
            ...query,
        };

        const fiveMinutesAgo = Date.now() - 300000;
        const requestId = JSON.stringify({ combinedParams, id, url });
        const cachedRequest = state.getIn(['cache', requestId], Map({}));
        const fetchedInPastFiveMinutes = cachedRequest.get('lastFetched', 0) > fiveMinutesAgo;
        const isCacheEqualToState = cachedRequest.get('data', Map({})).equals(state.get('data', Map({})));
        const { EDIT_IN, FETCH, FETCH_FAIL, FETCH_SUCCESS } = types;

        // If result is cached do not make call again and use cached data
        if (isCacheEqualToState && fetchedInPastFiveMinutes && !refresh) {
            dispatch({
                path: ['data'],
                type: EDIT_IN,
                value: cachedRequest.get('data'),
            });

            return Promise.resolve();
        }

        return dispatch({
            payload: {
                request: {
                    params: combinedParams,
                    url: `${url}/${id}`,
                },
            },
            types: [FETCH, FETCH_SUCCESS, FETCH_FAIL],
        });
    };
};

export const createPatch = ({
    params = {},
    types,
    url,
}) => {
    return (id, data, query = {}) => (dispatch) => {
        const { PATCH, PATCH_FAIL, PATCH_SUCCESS } = types;

        const combinedParams = fromJS({
            ...params,
            ...query,
        });

        return dispatch({
            data,
            payload: {
                request: {
                    data,
                    method: 'patch',
                    params: combinedParams.toJS(),
                    url: `${url}/${id}`,
                },
            },
            types: [PATCH, PATCH_SUCCESS, PATCH_FAIL],
        });
    };
};

export const createPost = ({
    params = {},
    types,
    url,
}) => {
    return (data, query = {}) => (dispatch) => {
        const { POST, POST_FAIL, POST_SUCCESS } = types;

        const combinedParams = fromJS({
            ...params,
            ...query,
        });

        return dispatch({
            data,
            payload: {
                request: {
                    data,
                    method: 'post',
                    params: combinedParams.toJS(),
                    url,
                },
            },
            types: [POST, POST_SUCCESS, POST_FAIL],
        });
    };
};

export const createPut = ({
    params = {},
    types,
    url,
}) => {
    return (data, query = {}) => (dispatch) => {
        const { PUT, PUT_FAIL, PUT_SUCCESS } = types;

        const combinedParams = fromJS({
            ...params,
            ...query,
        });

        return dispatch({
            data,
            payload: {
                request: {
                    data,
                    method: 'put',
                    params: combinedParams.toJS(),
                    url: `${url}/${data.get('id')}`,
                },
            },
            types: [PUT, PUT_SUCCESS, PUT_FAIL],
        });
    };
};

export const createReset = ({ types: { RESET } }) => () => ({ type: RESET });

export const createCollectionActions = (props) => ({
    fetch: createFetchCollection(props),
    post: createPost(props),
    remove: createDelete(props),
    reset: createReset(props),
});

export const createResourceActions = (props) => ({
    fetch: createFetchResource(props),
    patch: createPatch(props),
    put: createPut(props),
    reset: createReset(props),
});



// WEBPACK FOOTER //
// ./src/utils/actionsGenerator.js